module.exports = __webpack_public_path__ + "static/ebr-2-266c9a4a569461d81496bee6d5723c1b.jpg";